export default __webpack_public_path__ + "static/f2-2e7dee0c301a34de6ddb4cc531aaed20.jpg";